import { Outlet, Route } from "react-router-dom"
import { pagesUrl } from "@app/core/appConstants"
import { withoutAppSideBar } from "@app/core/context/AppSideBarContext/AppSideBarContext"

export const BSRoutes = (
  // A variant's screens take the whole screen: no side bar.
  <Route element={<Outlet />} handle={withoutAppSideBar}>
    {/* Beem Shot main pages */}
    <Route lazy={() => import("./BSRouteLayout").then((module) => ({ Component: module.BSRouteLayout }))}>
      <Route
        path={pagesUrl.VARIANT_DETAILS}
        lazy={() =>
          import("@app/pages/projects/project/beem-shot/variant/BSVariantDetailsPage").then((module) => ({
            Component: module.BSVariantDetailsPage,
          }))
        }
      />

      <Route
        path={pagesUrl.BUILDING_CHOICE}
        lazy={() =>
          import(
            "@app/pages/projects/project/beem-shot/variant/building/BSCreateBuildingPages/BSMorphologyPage/BSMorphologyPage"
          ).then((module) => ({ Component: module.BSMorphologyPage }))
        }
      />
      <Route
        path={pagesUrl.BUILDING_ZONE}
        lazy={() =>
          import("@app/pages/projects/project/beem-shot/variant/building/BSCreateBuildingPages/BSZonePage/BSZonePage").then(
            (module) => ({ Component: module.BSZonePage })
          )
        }
      />
      <Route
        path={pagesUrl.BUILDING_LEVEL}
        lazy={() =>
          import(
            "@app/pages/projects/project/beem-shot/variant/building/BSCreateBuildingPages/BSLevelPage/BSLevelPage"
          ).then((module) => ({ Component: module.BSLevelPage }))
        }
      />
      <Route
        path={pagesUrl.BUILDING_FONDATION}
        lazy={() =>
          import(
            "@app/pages/projects/project/beem-shot/variant/building/BSCreateBuildingPages/BSBuildingFondationPage/BSFondationPage"
          ).then((module) => ({ Component: module.BSFondationPage }))
        }
      />
      <Route
        path={pagesUrl.BUILDING_REPARTITION}
        lazy={() =>
          import(
            "@app/pages/projects/project/beem-shot/variant/building/BSCreateBuildingPages/BSBuildingRepartitionPage/BSRepartitionPage"
          ).then((module) => ({ Component: module.BSRepartitionPage }))
        }
      />
      <Route
        path={pagesUrl.BUILDING_PARKING}
        lazy={() =>
          import(
            "@app/pages/projects/project/beem-shot/variant/building/BSCreateBuildingPages/BSBuildingParkingPage/BSParkingPage"
          ).then((module) => ({ Component: module.BSParkingPage }))
        }
      />
      <Route
        path={pagesUrl.BUILDING_PATIO}
        lazy={() =>
          import(
            "@app/pages/projects/project/beem-shot/variant/building/BSCreateBuildingPages/BSPatioPage/BSPatioPage"
          ).then((module) => ({ Component: module.BSPatioPage }))
        }
      />

      <Route
        path={pagesUrl.CALCUL}
        lazy={() => import("./BSCalculationRoutes").then((module) => ({ Component: module.BSCalculationRoute }))}
      />
      <Route
        path={pagesUrl.CALCUL_MORPHOLOGY}
        lazy={() => import("./BSCalculationRoutes").then((module) => ({ Component: module.BSMorphologyCalculationRoute }))}
      />
      <Route
        path={pagesUrl.BEEM_SHOT_CHANTIER}
        lazy={() =>
          import(
            "@app/pages/projects/project/beem-shot/variant/tabs/BSBuildingTabs/BSBuildingChantierTab/BSChantierPage"
          ).then((module) => ({ Component: module.BSChantierPage }))
        }
      />
    </Route>
  </Route>
)
